import styled from 'styled-components'
import { Button } from 'react-bootstrap'

const ButtonLink = styled(Button)`
  color: #588785;
  text-decoration: underline;
`

export default ButtonLink
